import { subscribe } from "./publish-subscribe";
import { setInitialized, getInitialized } from "./config/config-store";
import { eventSubscription } from "./events/events";
// import { init } from './initialize-passive';
// init();
import { configSubscription } from "./events/config";
import { trackElementsSubscription } from "./events/element";
import { pageViewSubscription } from "./events/page-view";
import { timerSubscription } from "./events/timer";
import { flushSubscription } from "./events/flush";
import { userSubscription } from "./events/user";
import { observeSubscription, unobserveSubscription } from "./events/observer";
const createInit = () => {
    const init = () => {
        subscribe("AAT_INITIALIZE_PASSIVE", () => {
            if (getInitialized()) {
                console.error("AAT passive tracking already initialized");
                return;
            }
            configSubscription();
            flushSubscription();
            eventSubscription();
            trackElementsSubscription();
            pageViewSubscription();
            timerSubscription();
            userSubscription();
            observeSubscription();
            unobserveSubscription();
            setInitialized(true);
        });
    };
    return { init };
};
export const { init } = createInit();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/initialize-passive.js
// module id = ./node_modules/@celine/passive-tracking/dist/initialize-passive.js
// module chunks = 0